(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-play.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-play.js');

'use strict';

var _svs$lyckoplatsen$dat, _mapCMS$mapSettings;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const getDefaultLocationName = svs.tur.lyckoplatsen.utils.getDefaultLocationName;
const scrambleCoordinates = svs.tur.lyckoplatsen.map.scrambleCoordinates;
const defaultStore = jotai.getDefaultStore();
const locationNameAtom = svs.lyckoplatsen.shared_map.atoms.locationNameAtom;
const _svs$tur$lyckoplatsen = svs.tur.lyckoplatsen.map,
  swe = _svs$tur$lyckoplatsen.swe,
  mapDefaults = _svs$tur$lyckoplatsen.mapDefaults,
  createMap = _svs$tur$lyckoplatsen.createMap,
  isPointInsideSweden = _svs$tur$lyckoplatsen.isPointInsideSweden,
  sweRectangleBounds = _svs$tur$lyckoplatsen.sweRectangleBounds,
  get3dPinIcon = _svs$tur$lyckoplatsen.get3dPinIcon,
  disableInteraction = _svs$tur$lyckoplatsen.disableInteraction,
  enableInteraction = _svs$tur$lyckoplatsen.enableInteraction;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_map,
  add3DMap = _svs$lyckoplatsen$com.add3DMap,
  show3DMap = _svs$lyckoplatsen$com.show3DMap,
  hide3DMap = _svs$lyckoplatsen$com.hide3DMap,
  hide3DMapCities = _svs$lyckoplatsen$com.hide3DMapCities,
  hide3DMapWeather = _svs$lyckoplatsen$com.hide3DMapWeather;
const fetchLocationName = svs.lyckoplatsen.shared_map.utils.fetchLocationName;
const logger = svs.lyckoplatsen.logger;

const mapCMS = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.map;
const enable3DMapCMS = mapCMS === null || mapCMS === void 0 ? void 0 : mapCMS.enable3DMap;
const clickCircleCMS = enable3DMapCMS ? mapCMS === null || mapCMS === void 0 || (_mapCMS$mapSettings = mapCMS.mapSettings) === null || _mapCMS$mapSettings === void 0 ? void 0 : _mapCMS$mapSettings.clickCircle : {};
function getPlayMapHandler() {
  let map;
  let eventHandlers = {};
  let nodeId;
  let mapActionInProgress = false;
  let disableMapInteraction = false;
  let sweRec;
  let pin;
  let options;
  let initCenterZoom;
  let initCenterCoords;
  let minZoom;
  let maxZoom;
  let delayInteraction = false;
  let clickTimeout;
  let zoomTimeout;
  let activeNameLocation = null;
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const isAndroid = svs.core.detect.os.android();
  return {
    createMap(mapOptions) {
      var _eventHandlers, _mapOptions$location;
      let evtHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options, () => eventHandlers.showMapErrorDialog());
      minZoom = mapOptions.minZoom;
      maxZoom = mapOptions.maxZoom;
      nodeId = mapOptions.nodeId;
      Object.assign(eventHandlers, evtHandlers);
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0,
        weight: 1
      });
      let bottomPadding = 0;
      if (options.charity) {
        bottomPadding = 116;
      }
      map.fitBounds(sweRec.getBounds(), {
        paddingTopLeft: [10, svs.core.detect.breakpoint.lessThan('lg') ? 56 : 85],
        paddingBottomRight: [10, bottomPadding],
        animate: false,
        minZoom,
        maxZoom
      });
      initCenterCoords = map.getCenter();
      initCenterZoom = map.getZoom();
      (_eventHandlers = eventHandlers) === null || _eventHandlers === void 0 || _eventHandlers.updateZoomLevel(map.getZoom());
      map.setMinZoom(initCenterZoom - 1);
      map.on('click', e => this.handleMapClickAndKeyPress(e));
      map.on('keydown', e => this.handleMapClickAndKeyPress(e));
      map.on('dblclick', e => {
        clearTimeout(clickTimeout);
        clickTimeout = null;
        if (mapActionInProgress) {
          return;
        }
        map.setView(e.latlng, map.getZoom() + 2, {
          animate: true
        });
      });
      this.addPanes();
      this.handleZoomButtonsEvents();
      this.handleMapActionEvents();
      eventHandlers.disableCenterMapButton(true);
      if ((_mapOptions$location = mapOptions.location) !== null && _mapOptions$location !== void 0 && _mapOptions$location.lat) {
        const zoomLevel = mapOptions.zoomLevel || options.maxZoom;
        map.setView(mapOptions.location, zoomLevel, {
          animate: false
        });
      }
      add3DMap(map);
      return map;
    },
    addPanes() {
      let playCirclePane = map.getPane('play-circle');
      if (!playCirclePane) {
        playCirclePane = map.createPane('play-circle');
        playCirclePane.style.zIndex = 551;
        playCirclePane.style.pointerEvents = 'none';
        playCirclePane.classList.add('gsap-play-circle-pane');
      }
    },
    initView() {
      map.setView(initCenterCoords, initCenterZoom, {
        animate: false
      });
    },
    handleZoomButtonsEvents() {
      map.whenReady(() => {
        const zoomInButton = document.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = document.querySelector('.leaflet-control-zoom-out');
        if (zoomInButton) {
          zoomInButton.addEventListener('click', () => {});
        }
        if (zoomOutButton) {
          zoomOutButton.addEventListener('click', () => {});
        }
      });
    },
    handleMapClickAndKeyPress(e) {
      if (clickTimeout) {
        return;
      }
      clickTimeout = setTimeout(() => {
        var _e$originalEvent, _e$latlng, _e$latlng2, _location, _location2;
        if (mapActionInProgress || (_e$originalEvent = e.originalEvent) !== null && _e$originalEvent !== void 0 && (_e$originalEvent = _e$originalEvent.target) !== null && _e$originalEvent !== void 0 && _e$originalEvent.closest('.leaflet-control')) {
          clickTimeout = null;
          return;
        }
        let location;
        let zoomLevel;
        switch (e.type) {
          case 'click':
            location = {
              lat: Number((_e$latlng = e.latlng) === null || _e$latlng === void 0 ? void 0 : _e$latlng.lat.toFixed(6)),
              lng: Number((_e$latlng2 = e.latlng) === null || _e$latlng2 === void 0 ? void 0 : _e$latlng2.lng.toFixed(6))
            };
            zoomLevel = map.getZoom();
            break;
          case 'keydown':
            if (e.originalEvent.key === 'Enter') {
              var _map;
              const center = (_map = map) === null || _map === void 0 ? void 0 : _map.getCenter();
              location = {
                lat: scrambleCoordinates(Number(center === null || center === void 0 ? void 0 : center.lat.toFixed(6))),
                lng: scrambleCoordinates(Number(center === null || center === void 0 ? void 0 : center.lng.toFixed(6)))
              };
              zoomLevel = map.getZoom();
            } else if (e.originalEvent.key === 'Escape') {
              var _eventHandlers2, _eventHandlers2$mapCl;
              (_eventHandlers2 = eventHandlers) === null || _eventHandlers2 === void 0 || (_eventHandlers2$mapCl = _eventHandlers2.mapClicked) === null || _eventHandlers2$mapCl === void 0 || _eventHandlers2$mapCl.call(_eventHandlers2);
              this.removePin();
            }
            break;
          default:
        }
        const inTerritory = isPointInsideSweden([(_location = location) === null || _location === void 0 ? void 0 : _location.lat, (_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.lng], swe.features[0].geometry.coordinates);
        if (inTerritory) {
          var _eventHandlers3, _eventHandlers3$mapCl;
          (_eventHandlers3 = eventHandlers) === null || _eventHandlers3 === void 0 || (_eventHandlers3$mapCl = _eventHandlers3.mapClicked) === null || _eventHandlers3$mapCl === void 0 || _eventHandlers3$mapCl.call(_eventHandlers3, location, zoomLevel, false);
        } else {
          if (pin) {
            this.removePin();
          }
          this.placeErrorCircle(location);
        }
        clickTimeout = null;
      }, 250);
    },
    handleMapActionEvents() {
      const mapEl = document.getElementById('mapPlay');
      const handleStart = () => {
        var _eventHandlers4, _eventHandlers4$updat;
        eventHandlers.disableCenterMapButton(false);
        (_eventHandlers4 = eventHandlers) === null || _eventHandlers4 === void 0 || (_eventHandlers4$updat = _eventHandlers4.updateIsMoving) === null || _eventHandlers4$updat === void 0 || _eventHandlers4$updat.call(_eventHandlers4, true);
        mapActionInProgress = true;
        disableMapInteraction && disableInteraction(map);
        if (mapEl && mapEl.classList.contains('svs-keyboard-focus')) {
          mapEl.blur();
        }
      };
      const handleEnd = () => {
        var _eventHandlers5, _eventHandlers5$updat, _eventHandlers8;
        (_eventHandlers5 = eventHandlers) === null || _eventHandlers5 === void 0 || (_eventHandlers5$updat = _eventHandlers5.updateIsMoving) === null || _eventHandlers5$updat === void 0 || _eventHandlers5$updat.call(_eventHandlers5, false);
        if (!pin && !delayInteraction) {
          this.mapEnabled();
        }
        if (delayInteraction) {
          var _eventHandlers6, _eventHandlers6$updat;
          mapActionInProgress = true;
          (_eventHandlers6 = eventHandlers) === null || _eventHandlers6 === void 0 || (_eventHandlers6$updat = _eventHandlers6.updateIsMoving) === null || _eventHandlers6$updat === void 0 || _eventHandlers6$updat.call(_eventHandlers6, true);
        } else {
          var _eventHandlers7, _eventHandlers7$updat;
          mapActionInProgress = false;
          (_eventHandlers7 = eventHandlers) === null || _eventHandlers7 === void 0 || (_eventHandlers7$updat = _eventHandlers7.updateIsMoving) === null || _eventHandlers7$updat === void 0 || _eventHandlers7$updat.call(_eventHandlers7, false);
        }
        (_eventHandlers8 = eventHandlers) === null || _eventHandlers8 === void 0 || _eventHandlers8.updateZoomLevel(map.getZoom());
        if (mapEl && mapEl.classList.contains('svs-keyboard-focus')) {
          mapEl.focus();
        }
      };
      const handleZoomStart = () => {
        handleStart();
        clearTimeout(zoomTimeout);
        zoomTimeout = setTimeout(() => {
          const currentZoom = map.getZoom();
          if (initCenterZoom < currentZoom) {
            hide3DMap(map);
          }
          if (initCenterZoom > currentZoom) {
            hide3DMapWeather(map);
            hide3DMapCities(map);
          }
        }, 300);
      };
      const handleZoomEnd = () => {
        handleEnd();
        if (initCenterZoom >= map.getZoom()) {
          show3DMap(map);
        }
        if (initCenterZoom > map.getZoom()) {
          hide3DMapWeather(map);
          hide3DMapCities(map);
        }
      };
      map.on('movestart', handleStart);
      map.on('zoomstart', handleZoomStart);
      map.on('zoomend', handleZoomEnd);
      map.on('moveend', handleEnd);
    },
    mapDisable() {
      disableMapInteraction = true;
      disableMapInteraction && disableInteraction(map);
    },
    mapEnabled() {
      disableMapInteraction && enableInteraction(map);
      disableMapInteraction = false;
    },
    removeMap() {
      if (pin) {
        try {
          if (pin && pin.isPopupOpen && pin.isPopupOpen()) {
            pin.closePopup();
          }
        } catch (err) {
        }
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
        }
        pin = null;
      }

      if (map) {
        try {
          if (typeof map.closePopup === 'function') {
            const hasPopup = map._popup;
            if (hasPopup && typeof hasPopup.close === 'function') {
              map.closePopup();
            }
          }
        } catch (err) {
        }
        try {
          if (typeof map.closeTooltip === 'function') {
            const hasTooltip = map._tooltip;
            if (hasTooltip && typeof hasTooltip.close === 'function') {
              map.closeTooltip();
            }
          }
        } catch (err) {
        }
      }

      if (sweRec) {
        try {
          if (sweRec && sweRec.remove) {
            sweRec.remove();
          }
        } catch (err) {
        }
        sweRec = null;
      }

      if (map) {
        try {
          map.off('movestart');
          map.off('zoomstart');
          map.off('zoomend');
          map.off('moveend');
          map.off();
          map.remove();
        } catch (err) {
        }
        map = null;
      }

      eventHandlers = {};
      options = null;
    },
    focusMap() {
      const mapEl = document.getElementById('mapPlay');
      mapEl.blur(); 
      mapEl.focus();
    },
    addEventHandlers(handlers) {
      Object.entries(handlers).forEach(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          handler = _ref2[1];
        eventHandlers[key] = handler;
      });
    },
    moveTo(location) {
      var _location$zoomLevel, _map2;
      if (!map) {
        return;
      }
      delayInteraction = location.delay || false;
      if (delayInteraction) {
        mapActionInProgress = true;
      }
      disableMapInteraction = true;
      let zoomLevel = (_location$zoomLevel = location.zoomLevel) !== null && _location$zoomLevel !== void 0 ? _location$zoomLevel : (_map2 = map) === null || _map2 === void 0 ? void 0 : _map2.getZoom();
      let delayTime = location.delay ? location.delay * 1000 : 0;
      if (location.resetView) {
        this.initView();
      }

      if (typeof location.onStart === 'function') {
        location.onStart(this);
      }
      if (location.campaignZoom) {
        zoomLevel = location.campaignZoom;
      }
      const executeFlyTo = () => map.flyTo(location, zoomLevel);
      if (isNativeApp && isAndroid) {
        delayTime += 300;
      }
      setTimeout(executeFlyTo, delayTime);
      map.once('moveend', () => {
        this.focusMap();
        disableMapInteraction = false;
        enableInteraction(map);
        if (delayInteraction) {
          var _eventHandlers9, _eventHandlers9$updat;
          (_eventHandlers9 = eventHandlers) === null || _eventHandlers9 === void 0 || (_eventHandlers9$updat = _eventHandlers9.updateIsMoving) === null || _eventHandlers9$updat === void 0 || _eventHandlers9$updat.call(_eventHandlers9, false);
          mapActionInProgress = false;
          delayInteraction = false;
        }

        if (typeof location.onComplete === 'function') {
          location.onComplete(this);
        }
      });
    },
    centerMap() {
      var _map3;
      map.once('moveend', () => {
        eventHandlers.disableCenterMapButton(true);
      });
      (_map3 = map) === null || _map3 === void 0 || _map3.setView(initCenterCoords, initCenterZoom, {
        animate: false
      });
    },
    getZoomLevel() {
      var _map4;
      return (_map4 = map) === null || _map4 === void 0 ? void 0 : _map4.getZoom();
    },

    pinHide(tl) {
      tl.set(".lp-3dpin", {
        opacity: 0,
        scale: 0
      });
    },
    pinAnimate(tl) {
      var _eventHandlers$showPi, _eventHandlers0;
      (_eventHandlers$showPi = (_eventHandlers0 = eventHandlers).showPin) === null || _eventHandlers$showPi === void 0 || _eventHandlers$showPi.call(_eventHandlers0, true);
      tl.to("#".concat(nodeId, " .lp-3dpin"), {
        opacity: 1,
        scale: 1,
        duration: 0.75,
        ease: 'power4.out'
      });
    },
    pinAdd(pin) {
      pin === null || pin === void 0 || pin.addTo(map);
    },
    async addLocationName(location, charity, locationType) {
      activeNameLocation = location;
      let locationName = getDefaultLocationName();
      const isHomeLocation = locationType === CONSTANTS.LOCATION_TYPES.HOME;
      if (isHomeLocation) {
        var _svs$lyckoplatsen$dat2, _svs$lyckoplatsen$dat3;
        const _ref3 = (_svs$lyckoplatsen$dat2 = (_svs$lyckoplatsen$dat3 = svs.lyckoplatsen.data.homeLocation) === null || _svs$lyckoplatsen$dat3 === void 0 ? void 0 : _svs$lyckoplatsen$dat3.playerAddress) !== null && _svs$lyckoplatsen$dat2 !== void 0 ? _svs$lyckoplatsen$dat2 : {},
          street = _ref3.street,
          town = _ref3.town;
        if (street && town) {
          locationName = "".concat(street, ", ").concat(town);
        }
        defaultStore.set(locationNameAtom, locationName);
      } else {
        try {
          var _locationName$county, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _locationName$pointOf;
          locationName = await fetchLocationName(location);
          if (activeNameLocation !== location) {
            return;
          }
          const locationCounty = (_locationName$county = locationName.county) !== null && _locationName$county !== void 0 ? _locationName$county : location.region;
          locationName = (_ref4 = (_ref5 = (_ref6 = (_ref7 = (_ref8 = (_ref9 = (_ref0 = (_locationName$pointOf = locationName.pointOfInterest) !== null && _locationName$pointOf !== void 0 ? _locationName$pointOf : locationName.neighbourhood) !== null && _ref0 !== void 0 ? _ref0 : locationName.natureReserve) !== null && _ref9 !== void 0 ? _ref9 : locationName.naturePark) !== null && _ref8 !== void 0 ? _ref8 : locationName.locality) !== null && _ref7 !== void 0 ? _ref7 : locationName.localAdmin) !== null && _ref6 !== void 0 ? _ref6 : locationName.county) !== null && _ref5 !== void 0 ? _ref5 : locationName.region) !== null && _ref4 !== void 0 ? _ref4 : getDefaultLocationName();
          if (locationCounty && locationCounty !== locationName) {
            locationName += ", ".concat(locationCounty);
          }
          defaultStore.set(locationNameAtom, locationName);
        } catch (error) {
          locationName = getDefaultLocationName();
          logger.warn('Failed to fetch location name', error);
        }
      }
    },
    placePin(_ref1) {
      let location = _ref1.location,
        zoomLevel = _ref1.zoomLevel,
        _ref1$animateFlyTo = _ref1.animateFlyTo,
        animateFlyTo = _ref1$animateFlyTo === void 0 ? false : _ref1$animateFlyTo;
      if (!map) {
        return;
      }
      const icon = get3dPinIcon({
        color: 'red',
        useDefaultIconSizes: false
      });
      pin = leaflet.marker(location, {
        icon
      });
      const tl = gsap.timeline();
      if (animateFlyTo) {
        var _map5, _map6;
        disableMapInteraction = true;
        disableInteraction(map);
        (_map5 = map) === null || _map5 === void 0 || _map5.flyTo(location, zoomLevel);
        (_map6 = map) === null || _map6 === void 0 || _map6.once('moveend', () => {
          disableMapInteraction = false;
          enableInteraction(map);
          this.pinAdd(pin);
          this.pinHide(tl);
          this.pinAnimate(tl);
        });
      } else {
        this.pinAdd(pin);
        this.pinHide(tl);
        this.pinAnimate(tl);
      }
      return pin;
    },
    removeCircle(circle) {
      circle.remove();
    },
    removePin() {
      let _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$keepShouldShow = _ref10.keepShouldShowPin,
        keepShouldShowPin = _ref10$keepShouldShow === void 0 ? false : _ref10$keepShouldShow;
      if (pin) {
        this.mapEnabled();
        try {
          if (pin && pin.isPopupOpen && pin.isPopupOpen()) {
            pin.closePopup();
          }
        } catch (err) {
        }
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
        }
        pin = null;
      }

      if (map) {
        try {
          if (typeof map.closePopup === 'function') {
            const hasPopup = map._popup;
            if (hasPopup && typeof hasPopup.close === 'function') {
              map.closePopup();
            }
          }
        } catch (err) {
        }
      }
      if (!keepShouldShowPin) {
        var _eventHandlers$showPi2, _eventHandlers1;
        (_eventHandlers$showPi2 = (_eventHandlers1 = eventHandlers).showPin) === null || _eventHandlers$showPi2 === void 0 || _eventHandlers$showPi2.call(_eventHandlers1, false);
      }
      this.focusMap();
    },
    circleAnimate(tl) {
      let slowdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      let opacityValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.25;
      tl.timeScale(slowdown);
      tl.set(".circle-animate", {
        opacity: 0,
        scale: 0,
        transformOrigin: '50% 50%'
      });
      tl.to(".circle-animate", {
        scale: 1,
        duration: 0.4,
        ease: 'back.out(1.2)'
      }, '<');
      tl.to(".circle-animate", {
        opacity: opacityValue,
        duration: 0.25
      }, '<');
      tl.to(".circle-animate", {
        opacity: 0,
        duration: 0.15,
        delay: 0.25
      }, '<');
    },
    placeErrorCircle(location) {
      if (!map || !map._loaded || !location) {
        return null;
      }
      const circle = leaflet.circleMarker(location, {
        color: 'red',
        radius: 20,
        weight: 0,
        fillOpacity: 1,
        className: 'cirlce-error circle-animate',
        pane: 'play-circle'
      });
      circle.addTo(map);
      const tl = gsap.timeline({
        onComplete: () => this.removeCircle(circle)
      });
      this.circleAnimate(tl);
      return circle;
    },
    placeStartClickCircle(location) {
      if (!map || !map._loaded || !location) {
        return null;
      }
      const circle = leaflet.circleMarker(location, {
        color: (clickCircleCMS === null || clickCircleCMS === void 0 ? void 0 : clickCircleCMS.color) || '#2073e5',
        radius: 30,
        weight: (clickCircleCMS === null || clickCircleCMS === void 0 ? void 0 : clickCircleCMS.strokeWidth) || 0,
        fillOpacity: 1,
        className: 'cirlce-from-start circle-animate',
        pane: 'play-circle'
      });
      circle.addTo(map);
      const tl = gsap.timeline({
        delay: 0.20,
        onComplete: () => this.removeCircle(circle)
      });
      this.circleAnimate(tl, 0.32, 0.85);
      return circle;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getPlayMapHandler
});

 })(window);